import {trackShopFeature} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {useTracking} from '../utils/utils';

export type FEATURE_TYPE =
  | 'click'
  | 'impression'
  | 'close'
  | 'submit'
  | 'faulty_shop_the_look_error'
  | 'swipe'
  | 'scroll'
  | 'like'
  | 'dislike'
  | 'open'
  | 'hover';

interface TrackFeatureProps {
  eventType: FEATURE_TYPE;
  label?: string | null;
  value?: string | number;
  name?: string | null;
}

/**
 * Allow to track the shop feature event.
 * Use the useTrackFeatureInViewImpression hook if you want to track 'impression' only when your component it's in view.
 * @returns The tracking feature function.
 */
export const useTrackFeature = () => {
  const {TrackingClient} = useTracking();
  const getPageContext = useTrackingPageContextCallback();

  return useCallback(
    ({eventType, label, value, name}: TrackFeatureProps) => {
      const pageContext = getPageContext();

      return TrackingClient.track(
        trackShopFeature({
          feature: {
            type: eventType,
            label: label ?? null,
            value: value ?? null,
            name: name ?? label,
            page_type: pageContext?.type,
            page_type_id: pageContext?.id,
          },
        }),
      );
    },
    [TrackingClient, getPageContext],
  );
};
